import { State } from '../types';

export type PepperReview = State['pepperReview'];

export enum ACTION_TYPES {
  STORE_PEPPER_REVIEW_SUCCESS = 'CM/CASE/PEPPER_REVIEW/STORE/SUCCESS',
}
